


















































































// @ is an alias to /src
import EditForm from '@/modules/core/components/EditForm.vue';
import AgencySelect from '@/modules/agency/components/AgencySelect.vue';
import RoleSelect from './RoleSelect.vue';
import { userApi } from '@/modules/user/user.api';
import { RoleType, roles } from '@shared/common/types';
import { User } from '../user';
import { debounce } from '@/modules/core/decorators/debounce';
import AuthenticationService from '@/auth.service';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { UserFormModel } from '../user.form-model';
import { plainToClass } from 'class-transformer';
import EditFormClass from '@/modules/core/components/EditForm';
import store from '../../../store';

@Component({
  components: {
    EditForm,
    AgencySelect,
    RoleSelect,
  },
})
export default class UserEdit extends EditFormClass {
  @Prop({
    default: null,
  })
  public userId!: string;

  @Prop({
    default: null,
  })
  public value!: any;

  @Prop({
    default: true,
  })
  public allowSave!: boolean;

  @Prop({
    default: null,
  })
  public label!: string;

  @Prop({
    default: null,
  })
  public title!: string;

  @Prop()
  public showInvalidMsg!: boolean;

  @Prop({
    default: false,
  })
  public forceRole!: boolean;

  public RoleType = RoleType;
  public formModel = new UserFormModel();
  public entityCreatedMsg = 'Utilisateur créé';
  public entityUpdatedMsg = 'Utilisateur mis à jour';
  public formModelClass = UserFormModel;
  public api = userApi;

  public get roleVisible(): boolean {
    return this.canSetRole && !this.forceRole;
  }

  public get creation(): boolean {
    return !this.value || (this.value && !this.value.id) || !this.userId;
  }

  public get shouldSetPassword(): boolean {
    return (
      (AuthenticationService.user as User).isAdmin() &&
      this.formModel.role !== RoleType.SUBSCRIBER
    );
  }

  public get canSetAgency(): boolean {
    return (
      (AuthenticationService.user as User).is(RoleType.NATIONAL_MANAGER) &&
      this.formModel.role !== RoleType.ADMIN
    );
  }

  public get canSetRole(): boolean {
    const user = AuthenticationService.user as User;
    return (
      user.isAdmin() ||
      (user.getSelectableRoles().length > 0 && !this.isEditingCurrentUser)
    );
  }

  public get isEditingCurrentUser(): boolean {
    const user = AuthenticationService.user as User;
    return user.id === this.formModel.id;
  }

  public get cardTitle(): string {
    if (this.title) {
      return this.title;
    }

    if (this.label) {
      return this.label;
    }

    if (this.creation) {
      if (this.formModel.role) {
        return (
          (roles[this.formModel.role as RoleType] &&
            roles[this.formModel.role as RoleType].creationLabel) ||
          'Nouvel utilisateur'
        );
      } else {
        return 'Nouvel utilisateur';
      }
    } else {
      return `Edition de ${this.formModel.fullname}`;
    }
  }

  public get entityId(): string {
    return this.userId;
  }

  // creation() {
  //   return !this.user && !this.userId;
  // },
  public get saveLabel(): string {
    return this.creation ? 'Créer' : 'Enregistrer';
  }

  public getUserTypeLabel(translateType: string): string {
    const labels = {
      [RoleType.SUBSCRIBER]: { name: 'Abonné', new: 'Nouvel abonné' },
      [RoleType.MANAGER]: {
        name: 'Gestionnaire',
        new: 'Nouveau gestionnaire',
      },
      [RoleType.ADMIN]: { name: 'Admin', new: 'Nouvel admin' },
    };

    const defaults = {
      name: 'Utilisateur',
      new: 'Nouvel utilisateur',
      edit: 'Edition de l\'utilisateur',
    };

    return (
      ((labels as any)[this.formModel.role] &&
        (labels as any)[this.formModel.role as string][translateType]) ||
      (defaults as any)[translateType]
    );
  }

  public async cancel(): Promise<void> {
    this.$emit('cancel');
  }

  public async update(): Promise<void> {
    const refreshAppUserOnSuccess = this.isEditingCurrentUser;

    try {
      const userUpdated = await this.$super(EditFormClass).update();
      if (refreshAppUserOnSuccess) {
        store.commit('user', userUpdated);
      }
    } catch (e) {
      throw e;
    }
  }

  @debounce(300)
  public onEmailChange(): void {
    this.checkEmailAvailability();
  }

  public onRoleChange(): void {
    if (this.formModel.role === RoleType.SUBSCRIBER) {
      this.formModel.email = undefined;
      this.formModel.password = undefined;
    }
  }

  public async checkEmailAvailability(): Promise<void> {
    this.formModel.validateField('email');
  }

  @Watch('value', { immediate: true })
  public onValueChange(): void {
    if (!this.value && !this.userId) {
      this.$emit('input', {});
    }

    if (this.formModel && this.creation && !this.$isAdmin()) {
      this.formModel.agencyId = (AuthenticationService.user as User).agencyId;
    }
  }

  @Watch('userId', { immediate: true })
  public async onUserIdChange(newVal: string): Promise<void> {
    if (newVal) {
      this.getEntity();
    } else {
      this.fetchedEntity = null;
    }
  }

  @Watch('value', { immediate: true })
  public onUserPropChange(): void {
    if (this.value) {
      if (this.value instanceof UserFormModel) {
        this.formModel = this.value;
      } else {
        this.formModel = plainToClass(UserFormModel, this.value);
        this.formModel.original = this.value;
      }
    }

    if (this.formModel && this.creation && !this.$isAdmin()) {
      this.formModel.agencyId = this.$user.agencyId;
    }
  }
}
